export default __webpack_public_path__ + "static/media/024-fox.755b587a.svg";